import { AnalyticsContext } from '@carvana/eventable-clickstream';
import React, { useContext } from 'react';
import ModalContext from '|/app/modals';
import { rollBack } from '|/app/services';
import * as sc from '|/app/steps/navigation-rail/edit-order-modal/edit-order-modal.styles';
import AppFrameworkContext from '|/helpers/app-framework';

const defaultProps = {
  deliveryPreference: null as null | string
};

const purchaseEditOrderRouteWhitelist = [
  'identity-verification',
  'bank-account-verification',
  'income-information',
  'residency-information',
  'trade-documentation',
  'additional-income',
  'transfer-schedule'
];

const redirectToPurchaseProcess = () => {
  window.location.href = '/purchase';
};

const EditOrderModal = (props = defaultProps) => {
  const { deliveryPreference } = props;
  const [, , route] = window.location.pathname.split('/');
  const { trackEvent } = useContext(AnalyticsContext);
  const { submit } = useContext(AppFrameworkContext);

  const deliveryOrPickup = deliveryPreference
    ?.toLowerCase()
    .includes('delivery')
    ? 'delivery'
    : 'pickup';
  const isOrderPlaced = route === 'order-placed';

  const confirmEditOrder = () => {
    trackEvent('v2_opd_edit_order_button_tap');
    if (purchaseEditOrderRouteWhitelist.includes(route))
      trackEvent('v2_finalize_purchase_edit_button_clicked');
    submit(
      rollBack({ cancelTransfer: true }).then(() => redirectToPurchaseProcess())
    );
  };

  const { setEditOrderModalOpen } = useContext(ModalContext);

  return (
    <sc.ContentWrapper>
      <sc.AlertIcon />
      {isOrderPlaced ? (
        <>
          <sc.BoldText>
            This will release your {deliveryOrPickup} date
          </sc.BoldText>
          <sc.BodyText>
            Editing your order will release your {deliveryOrPickup} appointment
            and{' '}
            <b>
              your vehicle will become available for others to purchase if you
              don't schedule a new appointment before the timer expires
            </b>
          </sc.BodyText>
        </>
      ) : (
        <>
          <sc.BoldText>Are you sure you want to edit your order?</sc.BoldText>
          <sc.BodyText>
            You will have a limited time to make your changes, otherwise your
            vehicle will become unlocked and available for others to purchase.
          </sc.BodyText>
        </>
      )}
      <sc.ButtonWrapper>
        <sc.Button
          onClick={confirmEditOrder}
          hierarchyType="secondary"
          size="large"
          color="blue"
          icon="none"
          text={isOrderPlaced ? 'Release delivery date' : 'Yes, edit'}
          data-analytics-id="pp_edit_modal_edit"
        />
        <sc.Button
          hierarchyType="primary"
          size="large"
          color="blue"
          icon="none"
          text={isOrderPlaced ? 'Go back' : 'No, go back'}
          onClick={() => setEditOrderModalOpen(false)}
          data-analytics-id="pp_edit_order_cancel"
        />
      </sc.ButtonWrapper>
    </sc.ContentWrapper>
  );
};

export default EditOrderModal;
